import { selectImprovementsGla } from '../../../redux/features/selectors/propertyDataSelectors/improvementsSelectors.ts';
import { selectGlaAndBathCostNew } from '../../../redux/features/selectors/selectGlaAndBathCostNew.ts';
import { CostApproachTableCostRow } from '../CostApproachTableCostRow.tsx';

export const DwellingCostRow = () => (
  <CostApproachTableCostRow
    label="Dwelling"
    areaSelector={selectImprovementsGla}
    costSelector={selectGlaAndBathCostNew}
  />
);
